// extracted by mini-css-extract-plugin
module.exports = {"spin-loader":"spin-loader_2P4Vk"};